import { render } from "./EditBuyGetFreePromotion.vue?vue&type=template&id=1b56b16a&scoped=true"
import script from "./EditBuyGetFreePromotion.vue?vue&type=script&lang=js"
export * from "./EditBuyGetFreePromotion.vue?vue&type=script&lang=js"

import "./EditBuyGetFreePromotion.vue?vue&type=style&index=0&id=1b56b16a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b56b16a"]])

export default __exports__